



















































































import Component from 'vue-class-component'
import Switcher from '@/components/Switcher.vue'
import Icon from '@/components/Icon.vue'
import ScrollView from '@/components/ScrollView.vue'
import { IResidentContact } from '@zunta/configurations'
import { isAddressValid, isEmailValid } from '@/utils/helpers'
import Vue from 'vue'

@Component({
  props: {
    contacts: {
      type: Array,
      required: true
    },
    selected: {
      type: Object,
      required: true
    },
    isAddressValid: {
      type: Function,
      default: isAddressValid
    },
    isEmailValid: {
      type: Function,
      default: isEmailValid
    }
  },
  components: {
    Switcher,
    Icon,
    ScrollView
  }
})
export default class CollectionMailContacts extends Vue {
  mounted () {
    this.$emit('select', {
      addresses: this.$props.contacts.filter((contact: IResidentContact) => contact.isAddressUsedForMailing && isAddressValid(contact)),
      emails: this.$props.contacts.filter((contact: IResidentContact) => contact.isEmailUsedForMailing && isEmailValid(contact))
    })
  }

  residentAddress (mailContact: IResidentContact) {
    return (mailContact.addressLine1 ? mailContact.addressLine1 : '') + ' ' +
      (mailContact.addressLine2 ? mailContact.addressLine2 : '') + ' ' +
      (mailContact.addressLine3 ? mailContact.addressLine3 : '') + ' ' +
      (mailContact.city ? mailContact.city : '') + ', ' +
      (mailContact.state ? mailContact.state : '') + ' ' +
      (mailContact.zipCode ? mailContact.zipCode : '')
  }

  isValidContact (contact: IResidentContact) {
    return contact.city &&
      contact.state &&
      contact.zipCode &&
      (contact.addressLine2 ||
        contact.addressLine1 ||
        contact.addressLine3)
  }

  isAddressSelected (contact: IResidentContact) {
    return !!this.$props.selected.addresses
      .find((aContact: IResidentContact) => aContact.id === contact.id)
    // .find((aContact: IResidentContact) => aContact.id === contact.id && contact.isAddressUsedForMailing)
  }

  isEmailSelected (contact: IResidentContact) {
    return !!this.$props.selected.emails
      .find((eContact: IResidentContact) => eContact.id === contact.id)
    // .find((eContact: IResidentContact) => eContact.id === contact.id && contact.isEmailUsedForMailing)
  }

  switchAddressContact (contact: IResidentContact) {
    if (this.isAddressSelected(contact)) {
      this.$emit('select', {
        ...this.$props.selected,
        addresses: this.$props.selected.addresses.filter((aContact: IResidentContact) => aContact.id !== contact.id)
      })
      return
    }
    this.$emit('select', {
      ...this.$props.selected,
      addresses: this.$props.selected.addresses.concat([contact])
    })
  }

  switchEmailContact (contact: IResidentContact) {
    if (this.isEmailSelected(contact)) {
      this.$emit('select', {
        ...this.$props.selected,
        emails: this.$props.selected.emails.filter((eContact: IResidentContact) => eContact.id !== contact.id)
      })
      return
    }
    this.$emit('select', {
      ...this.$props.selected,
      emails: this.$props.selected.emails.concat([contact])
    })
  }
}
